import { inject } from '@angular/core';
import {
  collection,
  collectionData,
  CollectionReference,
  Firestore,
} from '@angular/fire/firestore';
import { Plan } from '@domain/aggregates';
import { PlansDataSource } from './plans.datasource';

export class FirebasePlansDataSource extends PlansDataSource {
  readonly #firestore = inject(Firestore);
  readonly #collection = collection(
    this.#firestore,
    'plans'
  ) as CollectionReference<Plan>;

  listPlans() {
    return collectionData(this.#collection);
  }
}
